let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eeaKR")).then(() => parcelRequire('i3uiK'));